import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteBookingSession } from '../api';
import { useSnackbarMsg } from '@/hooks/useSnackbarMsg';

type DeleteBookingSessionHookParams = {
  onSuccessFn?: (bookingSessionId: number) => void;
};

export default function useDeleteBookingSession({
  onSuccessFn,
}: DeleteBookingSessionHookParams = {}) {
  const queryClient = useQueryClient();
  const { errorMsg, successMsg } = useSnackbarMsg();

  const deleteSessionMutation = useMutation({
    mutationFn: (bookingSessionId: number) =>
      deleteBookingSession(bookingSessionId),
    onSuccess: (_data, bookingSessionId) => {
      successMsg(`Session #${bookingSessionId} deleted`);
      queryClient.invalidateQueries(['bookingSessions']);
      queryClient.removeQueries(['bookingSession', String(bookingSessionId)]);
      queryClient.invalidateQueries(['bookings']);
      onSuccessFn?.(bookingSessionId);
    },
    onError: (error) => {
      errorMsg(error, 'Something went wrong while deleting session');
    },
  });

  return { deleteSessionMutation };
}
